import styles from "./styles.module.scss";

interface Props {
  children?: any;
}

export function HeaderAtom(props: Readonly<Props>) {
  return <header className={styles.header}>{props.children}</header>;
}
